import { useLocalStorageState } from 'ahooks'

export default function useIdentity() {
  const [ uid, uidDispatch ] = useLocalStorageState<string>(`${APP_ENV.db}:uid`)
  const [ user, userDispatch ] = useLocalStorageState<any>(`${APP_ENV.db}:user`)
  const [ token, tokenDispatch ] = useLocalStorageState<string>(`${APP_ENV.db}:token`)

  const clear = R.compose(
    R.tap(uidDispatch),
    R.tap(userDispatch),
    R.tap(tokenDispatch),
  )

  const dispatch = R.cond([
    [R.equals('uid'), R.always(uidDispatch)],
    [R.equals('user'), R.always(userDispatch)],
    [R.equals('token'), R.always(tokenDispatch)],
  ])

  return {
    uid,
    user,
    token,
    clear: () => clear(undefined),
    isLogined: () => token != null,
    dispatch: (type: string, data: any) => dispatch?.(type)?.(data),
    hasPermission: (code: number) => R.any((permission: number) => code == permission, user?.permissions ?? []),
  }
}
